<template>
	<DefaultLayout>
		<InsertFloppyDialog floppy="SETTINGS" />
	</DefaultLayout>
</template>

<script>
	import { Component, Vue } from 'vue-property-decorator';
    import DefaultLayout from '../../layouts/Default/index.vue';
    import InsertFloppyDialog from '../../components/InsertFloppyDialog';

	@Component({
		components: {
			DefaultLayout,
			InsertFloppyDialog,
		},
	})
	export default class MyComponent extends Vue {
    	
	}
</script>

<style lang="scss">

</style>